export const isAllTruthy = (...args) => args.every(Boolean);
